import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Products from "./components/Products";
import Services from "./components/Services";
import Careers from "./components/Careers";
import ContactUs from "./components/ContactUs";
import About from "./components/About";
import Privacy from "./components/Privacy";
import Terms from "./components/Terms";
import Refund from "./components/Refund";
import Shipping from "./components/Shipping";
import JobDescription from "./components/JobDescription";
import Login from "./components/Login";
import ServiceDetailPage from "./components/ServiceDetailPage";
import AdminDashboard from "./components/AdminDashboard";
import ApplicationSuccess from "./components/ApplicationSuccess";
import ApplyForm from "./components/ApplyForm";
import NatureMissionPage from "./components/NatureMissionPage";



import "./index.css";

const App = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/services" element={<Services />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/about" element={<About />} />        {/* Added */}
        <Route path="/privacy" element={<Privacy />} />    {/* Added */}
        <Route path="/terms" element={<Terms />} />        {/* Added */}
        <Route path="/refund" element={<Refund />} />
        <Route path="/shipping" element={<Shipping />} />  {/* Added */}
        <Route path="/services/:id" element={<ServiceDetailPage />} />
        <Route path="/job/:id" element={<JobDescription />} />
        <Route path="/apply/:id" element={<ApplyForm />} /> 
        <Route path="/login" element={<Login />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/application-success" element={<ApplicationSuccess />} />
        <Route path="/refund" element={<Refund />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/about" element={<About />} />
        <Route path="/shipping" element={<Shipping />} />
        <Route path="/nature-mission" element={<NatureMissionPage />} />
      </Routes>
    </Router>
  );
};

export default App;